import angular from 'angular'
import { role } from 'redevConfig'

const add = (role && role.add) || ''
const list = (role && role.list) || ''

const roleListCtrl = list
  ? require(`redevelopment/system/role/${list.controllerName}`)
  : require('./roleListCtrl')
const editRoleCtrl = add
  ? require(`redevelopment/system/role/${add.controllerName}`)
  : require('./editRoleCtrl')

const roleListPage = list
  ? require(`redevelopment/system/role/${list.templateName}`)
  : require('./views/roleList.html')
const editRolePage = add
  ? require(`redevelopment/system/role/${add.templateName}`)
  : require('./views/editRole.html')

function config($stateProvider) {
  $stateProvider
    .state('system.permission.role', {
      url: '/role',
      template: '<div ui-view></div>',
      title: '角色管理',
      abstract: true,
      default: 'system.permission.role.list',
    })
    .state('system.permission.role.list', {
      url: '/list',
      controller: 'roleListCtrl',
      template: roleListPage,
    })
    .state('system.permission.role.add', {
      url: '/add',
      controller: 'editRoleCtrl',
      template: editRolePage,
      title: '新增',
    })
    .state('system.permission.role.edit', {
      url: '/edit/:roleId&:orgId',
      controller: 'editRoleCtrl',
      template: editRolePage,
      title: '编辑',
    })
}

export default angular
  .module('system.permission.role', [])
  .config(['$stateProvider', config])
  .controller('roleListCtrl', roleListCtrl.default)
  .controller('editRoleCtrl', editRoleCtrl.default).name



// WEBPACK FOOTER //
// ./src/app/system/permission/role/index.js